import { render } from "./LectureTypeCard.vue?vue&type=template&id=81fecc86"
import script from "./LectureTypeCard.vue?vue&type=script&lang=js"
export * from "./LectureTypeCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__